/* CAMPAIGN SOURCE DATA */
export const GET_CAMPAIGN_SOURCES_LIST = "GET_CAMPAIGN_SOURCES_LIST"
export const SET_CAMPAIGN_SOURCES_LIST = "SET_CAMPAIGN_SOURCES_LIST"

/* CAMPAIGNS SOURCE ACTIONS */
export const ADD_CAMPAIGN_SOURCE = "ADD_CAMPAIGN_SOURCE"
export const DELETE_CAMPAIGN_SOURCE = "DELETE_CAMPAIGN_SOURCE";

/* CAMPAIGN FORMAT PROFILE DATA */
export const GET_CAMPAIGN_SOURCE_PROFILE = "GET_CAMPAIGN_SOURCE_PROFILE"
export const SET_CAMPAIGN_SOURCE_PROFILE = "SET_CAMPAIGN_SOURCE_PROFILE"
export const UPDATE_CAMPAIGN_SOURCE_PROFILE = "UPDATE_CAMPAIGN_SOURCE_PROFILE"
export const SET_ERROR_CAMPAIGN_SOURCE_PROFILE = "SET_ERROR_CAMPAIGN_SOURCE_PROFILE"

/* LOADER */
export const SHOW_CAMPAIGN_SOURCES_LIST_LOADER = "SHOW_CAMPAIGN_SOURCES_LIST_LOADER"
export const HIDE_CAMPAIGN_SOURCES_LIST_LOADER = "HIDE_CAMPAIGN_SOURCES_LIST_LOADER"
